module.exports = __webpack_public_path__ + "img/117.0137ca8f.jpg";